import { Suspense, lazy, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router';
import SidebarLayout from 'src/layouts/SidebarLayout';
import SuspenseLoader from 'src/components/SuspenseLoader';
import ServicePartnerDetailsPage from 'src/content/pages/servicePartner/spDetailPage';
import { CustomerBookingCartProvider } from './content/pages/customer/selectedCustomerData';
import { RenewSubscription } from './content/pages/subscriptions/subscriptionOptions/renewSubscription';
import ProtectedRoute from './content/pages/auth/ProtectedRoute';
import { useAuth } from './contexts/AuthContext';
import Login from './content/pages/auth/Login';
import SalesPartnerDetails from './content/pages/settings/SalesPartner/SalesPartnerDetails';
import { CustomerBookingCart } from './content/pages/customer/customerBookingCart';
import DemoCustomerPageLayout from './content/pages/customer/CustomerBookingPageLayout';
import CustomerBookingPageLayout from './content/pages/customer/CustomerBookingPageLayout';


const CreateSubscriptionWithProvider = () => (
  <CustomerBookingCartProvider>
    <CreateSubscription />
  </CustomerBookingCartProvider>
);

const Loader = (Component) => (props) => (
  <Suspense fallback={<SuspenseLoader />}>
    <Component {...props} />
  </Suspense>
);

// Pages

const Overview = Loader(lazy(() => import('src/content/overview')));

// Dashboards

const Crypto = Loader(lazy(() => import('src/content/dashboards/Crypto')));

// Settings

const Region = Loader(lazy(() => import('src/content/pages/settings/regions')));

const Cars = Loader(lazy(() => import('src/content/pages/settings/cars')));

const Services = Loader(
  lazy(() => import('src/content/pages/settings/services'))
);

const Prices = Loader(lazy(() => import('src/content/pages/settings/price')));

const Packages = Loader(
  lazy(() => import('src/content/pages/settings/package'))
);

const Customer = Loader(lazy(() => import('src/content/pages/customer')));

const AddCustomer = Loader(
  lazy(() => import('src/content/pages/customer/customerBasicLayout'))
);

const CustomerCar = Loader(
  lazy(() => import('src/content/pages/customer/customerCarLayout'))
);

const UserManagement = Loader(
  lazy(() => import('src/content/pages/settings/userManagement'))
);

const SalesPartner = Loader(
  lazy(() => import('src/content/pages/settings/SalesPartner'))
)

const CustomerAppConfig = Loader(
  lazy(() => import('src/content/pages/settings/customerAppConfig'))
)

// Bookings

const BookingServices = Loader(
  lazy(() => import('src/content/pages/bookings/services'))
);

const BookingsBooking = Loader(
  lazy(() => import('src/content/pages/bookings/booking'))
);

// ServicePartner

const ServicePartner = Loader(
  lazy(() => import('src/content/pages/servicePartner'))
);

const ServicePartnerDetails = Loader(
  lazy(() => import('src/content/pages/servicePartner/spDetailPage'))
);

// Reports
const CustomersReport = Loader(
  lazy(() => import('src/content/pages/reports/customerReports'))
);

const SalesPartnersReport = Loader(
  lazy(() => import('src/content/pages/reports/salesPartnerReports'))
)

const ServicePartnersReport = Loader(
  lazy(() => import('src/content/pages/reports/servicePartnerReports'))
)

//Subscriptions
const Subscriptions = Loader(
  lazy(() => import('src/content/pages/subscriptions'))
);

const CreateSubscription = Loader(
  lazy(() => import('src/content/pages/subscriptions/createSubscription/createSubscriptionPageLayout'))
);
const SPServiceDetails = Loader(
  lazy(() => import('src/content/pages/servicePartner/spDetailPage/services/SPServiceDetails'))
)

//Scheduler
const Scheduler = Loader(
  lazy(() => import('src/content/pages/Scheduler'))
);

// Applications

const Messenger = Loader(
  lazy(() => import('src/content/applications/Messenger'))
);
const Transactions = Loader(
  lazy(() => import('src/content/applications/Transactions'))
);
const UserProfile = Loader(
  lazy(() => import('src/content/applications/Users/profile'))
);
const UserSettings = Loader(
  lazy(() => import('src/content/applications/Users/settings'))
);

// Components

const Buttons = Loader(
  lazy(() => import('src/content/pages/Components/Buttons'))
);
const Modals = Loader(
  lazy(() => import('src/content/pages/Components/Modals'))
);
const Accordions = Loader(
  lazy(() => import('src/content/pages/Components/Accordions'))
);
const Tabs = Loader(lazy(() => import('src/content/pages/Components/Tabs')));
const Badges = Loader(
  lazy(() => import('src/content/pages/Components/Badges'))
);
const Tooltips = Loader(
  lazy(() => import('src/content/pages/Components/Tooltips'))
);
const Avatars = Loader(
  lazy(() => import('src/content/pages/Components/Avatars'))
);
const Cards = Loader(lazy(() => import('src/content/pages/Components/Cards')));
const Forms = Loader(lazy(() => import('src/content/pages/Components/Forms')));

// Status

const Status404 = Loader(
  lazy(() => import('src/content/pages/Status/Status404'))
);
const Status500 = Loader(
  lazy(() => import('src/content/pages/Status/Status500'))
);
const StatusComingSoon = Loader(
  lazy(() => import('src/content/pages/Status/ComingSoon'))
);
const StatusMaintenance = Loader(
  lazy(() => import('src/content/pages/Status/Maintenance'))
);

const AuthWrapper = () => {
  const { token } = useAuth();
  return token ? <Navigate to="/dashboards" replace /> : <Login />;
};

const routes: RouteObject[] = [
  {
    path: '/login',
    element: <AuthWrapper />
  },
  // {
  //   path: '',
  //   element: <BaseLayout />,
  //   children: [
  //     {
  //       path: '/',
  //       element: <Overview />
  //     },
  //     {
  //       path: 'overview',
  //       element: <Navigate to="/" replace />
  //     },
  //     {
  //       path: 'status',
  //       children: [
  //         {
  //           path: '',
  //           element: <Navigate to="404" replace />
  //         },
  //         {
  //           path: '404',
  //           element: <Status404 />
  //         },
  //         {
  //           path: '500',
  //           element: <Status500 />
  //         },
  //         {
  //           path: 'maintenance',
  //           element: <StatusMaintenance />
  //         },
  //         {
  //           path: 'coming-soon',
  //           element: <StatusComingSoon />
  //         }
  //       ]
  //     },
  //     {
  //       path: '*',
  //       element: <Status404 />
  //     }
  //   ]
  // },
  {
    path: '/',
    element: <ProtectedRoute />,
    children: [
      {
        path: '/',
        element: <Navigate to="/dashboards" replace />
      },
      {
        path: '/dashboards',
        element: <SidebarLayout />,
        children: [
          {
            path: '',
            element: <Navigate to="crypto" replace />
          },
          {
            path: 'crypto',
            element: <Crypto />
          },
          {
            path: 'messenger',
            element: <Messenger />
          }
        ]
      },
      {
        path: '/settings',
        element: <SidebarLayout />,
        children: [
          {
            path: '',
            element: <Navigate to="regions" replace />
          },
          {
            path: 'regions',
            element: <Region />
          },
          {
            path: '',
            element: <Navigate to="cars" replace />
          },
          {
            path: 'cars',
            element: <Cars />
          },
          {
            path: '',
            element: <Navigate to="services" replace />
          },
          {
            path: 'services',
            element: <Services />
          },
          {
            path: '',
            element: <Navigate to="price" replace />
          },
          {
            path: 'price',
            element: <Prices />
          },
          {
            path: '',
            element: <Navigate to="packages" replace />
          },
          {
            path: 'packages',
            element: <Packages />
          },
          {
            path: 'user-management',
            element: <UserManagement />
          },
          {
            path: 'salesPartner',
            children: [
              { path: '', element: <SalesPartner /> },
              { path: 'salesPartnerDetailsPage', element: <SalesPartnerDetails /> }
            ]
          },
          {
            path: 'customer-app-config',
            element: <CustomerAppConfig />
          }
        ]
      },
      {
        path: 'customer',
        element: <SidebarLayout />,
        children: [
          {
            path: '',
            element: <Navigate to="customer" replace />
          },
          {
            path: 'customer',
            element: <Customer />
          },
          {
            path: '',
            element: <Navigate to="addCustomer" replace />
          },
          {
            path: 'addCustomer',
            element: <AddCustomer />
          },
          {
            path: '',
            element: <Navigate to="addCar" replace />
          },
          {
            path: 'addCar',
            element: <CustomerCar />
          }
        ]
      },
      {
        path: '/bookings',
        element: <SidebarLayout />,
        children: [
          {
            path: '',
            element: <Navigate to="bookingsServices" replace />
          },
          {
            path: '/bookingsServices',
            element: <BookingServices />
          },
          {
            path: '',
            element: <Navigate to="bookingsBooking" replace />
          },
          {
            path: '/bookingsBooking',
            element: <BookingsBooking />
          },
          {
            path: 'create', element: <CustomerBookingCartProvider>
              <CustomerBookingPageLayout />
            </CustomerBookingCartProvider>
          }
        ]
      },
      {
        path: '/servicePartner',
        element: <SidebarLayout />,
        children: [
          {
            path: '',
            element: <ServicePartner />
          },
          {
            path: 'servicePartnerDetailsPage',
            element: <ServicePartnerDetails />
          },
          {
            path: 'service-details/:id',
            element: <SPServiceDetails />
          }
        ]
      },
      {
        path: '/servicePartner',
        element: <SidebarLayout />,
        children: [
          {
            path: '',
            element: <Navigate to="servicePartner" replace />
          },
          {
            path: '/servicePartner',
            element: <ServicePartner />
          }
        ]
      },
      {
        path: '/reports',
        element: <SidebarLayout />,
        children: [
          {
            path: '',
            element: <Navigate to="customers" replace />
          },
          {
            path: 'customers',
            element: <CustomersReport />
          },
          {
            path: 'service-partners',
            element: <ServicePartnersReport />
          },
          {
            path: 'sales-partners',
            element: <SalesPartnersReport />
          },
          {
            path: 'services',
            // element: <ServicesReport />
          },
          {
            path: 'subscriptions',
            // element: <SubscriptionsReport />
          }
        ]
      },
      {
        path: '/subscriptions',
        element: <SidebarLayout />,
        children: [
          {
            path: '',
            element: <Navigate to="subscriptions" replace />
          },
          {
            path: 'subscriptions',
            element: <Subscriptions />
          },
          {
            path: 'create',
            element: <CreateSubscriptionWithProvider />
          },
        ]
      },
      {
        path: '/scheduler',
        element: <SidebarLayout />,
        children: [
          {
            path: '',
            element: <Scheduler />
          },
        ]
      },
      {
        path: 'management',
        element: <SidebarLayout />,
        children: [
          {
            path: '',
            element: <Navigate to="transactions" replace />
          },
          {
            path: 'transactions',
            element: <Transactions />
          },
          {
            path: 'profile',
            children: [
              {
                path: '',
                element: <Navigate to="details" replace />
              },
              {
                path: 'details',
                element: <UserProfile />
              },
              {
                path: 'settings',
                element: <UserSettings />
              }
            ]
          }
        ]
      },
      {
        path: '/components',
        element: <SidebarLayout />,
        children: [
          {
            path: '',
            element: <Navigate to="buttons" replace />
          },
          {
            path: 'buttons',
            element: <Buttons />
          },
          {
            path: 'modals',
            element: <Modals />
          },
          {
            path: 'accordions',
            element: <Accordions />
          },
          {
            path: 'tabs',
            element: <Tabs />
          },
          {
            path: 'badges',
            element: <Badges />
          },
          {
            path: 'tooltips',
            element: <Tooltips />
          },
          {
            path: 'avatars',
            element: <Avatars />
          },
          {
            path: 'cards',
            element: <Cards />
          },
          {
            path: 'forms',
            element: <Forms />
          }
        ]
      }]
  }, {
    path: "*",
    element: <Status404 />
  }
];

export default routes;
